import axios from "axios";
import { REACT_APP_API_URL } from "../env";

const BASE_URL = `${REACT_APP_API_URL}api/service-record`;

// Token based on cookies/session
const config = () => ({ withCredentials: true });

// GET THREAD LIST
export const getThreads = () =>
  axios.get(BASE_URL, config());

// GET THREAD DETAILS
export const getThreadById = (id) =>
  axios.get(`${BASE_URL}/${id}`, config());

// CREATE THREAD
export const createThread = (formData) =>
  axios.post(`${BASE_URL}/create`, formData, {
    ...config(),
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// GET EMPLOYEES FOR DROPDOWN
export const getEmployees = () =>
  axios.get(`${BASE_URL}/employees`, config());

// ADD REPLY
export const replyThread = (formData) =>
  axios.post(`${BASE_URL}/reply`, formData, {
    ...config(),
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// CLOSE THREAD
export const closeThread = (id) =>
  axios.put(`${BASE_URL}/close/${id}`, {}, config());

// REOPEN THREAD
export const reopenThread = (id) =>
  axios.put(`${BASE_URL}/reopen/${id}`, {}, config());